/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 60 to 45: ((60 − 45) ÷ 60) × 100 = 25% decrease.`)
};

const es_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 60 a 45: ((60 − 45) ÷ 60) × 100 = 25% de disminución.`)
};

const de_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von 60 auf 45: ((60 − 45) ÷ 60) × 100 = 25 % Rückgang.`)
};

const nl_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van 60 naar 45: ((60 − 45) ÷ 60) × 100 = 25% daling.`)
};

const fr_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 60 à 45 : ((60 − 45) ÷ 60) × 100 = diminution de 25 %.`)
};

const it_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 60 a 45: ((60 − 45) ÷ 60) × 100 = calo del 25%.`)
};

const pt_br2_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 60 para 45: ((60 − 45) ÷ 60) × 100 = 25% de diminuição.`)
};

const pt_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 60 para 45: ((60 − 45) ÷ 60) × 100 = 25% de diminuição.`)
};

const ja_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60から45へ: ((60 − 45) ÷ 60) × 100 = 25%減少。`)
};

const zh_pct_decrease_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 60 到 45：((60 − 45) ÷ 60) × 100 = 减少 25%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_ex2", locale)
	if (locale === "en") return en_pct_decrease_ex2(inputs)
	if (locale === "es") return es_pct_decrease_ex2(inputs)
	if (locale === "de") return de_pct_decrease_ex2(inputs)
	if (locale === "nl") return nl_pct_decrease_ex2(inputs)
	if (locale === "fr") return fr_pct_decrease_ex2(inputs)
	if (locale === "it") return it_pct_decrease_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_ex2(inputs)
	if (locale === "pt") return pt_pct_decrease_ex2(inputs)
	if (locale === "ja") return ja_pct_decrease_ex2(inputs)
	return zh_pct_decrease_ex2(inputs)
};